import(/* webpackMode: "eager", webpackExports: ["EventExperiencePage"] */ "/app/app/[locale]/(site)/event/_components/experience/event-experience-page.tsx");
